import PropTypes from "prop-types";
import ReactDOM from "react-dom";

const MODAL_ROOT_ID = "OkModal";

const ModalRoot = ({ children }) => {
	let el = document.getElementById(MODAL_ROOT_ID);

	if (!el) {
		const newElement = document.createElement("div");
		newElement.id = MODAL_ROOT_ID;
		document.body.appendChild(newElement);
		el = document.getElementById(MODAL_ROOT_ID);
	}

	return ReactDOM.createPortal(
		children,
		el,
	);
};

ModalRoot.propTypes = {
	children: PropTypes.node.isRequired,
};

export default ModalRoot;



// WEBPACK FOOTER //
// ./src/shared/components/ModalRoot/ModalRoot.jsx